<template>
    <div>
      <b-sidebar :visible="isSidebarOpen" @hidden="toggleSidebar" :sidebar-class="['sidebar-highlight', { 'sidebar-large': isSidebarLarge }]"  title="Shuttle Central" backdrop id="sidebar-highlight">
          <!-- Button to toggle sidebar size -->
        <div v-if="selectedModule" class="m-4">
         
          <b-tabs content-class="mt-3" align="center">
            <b-tab title="Status Vuelos" v-if="showFlightsStatusModule" active>
              <FlightsStatus></FlightsStatus>
            </b-tab>
            <b-tab title="Analisis Por proveedor">
              <SupplierAnalisis ref="supplier-analisis"></SupplierAnalisis>
            </b-tab>
            
          </b-tabs>
        </div>
        
        <template #footer="{ hide }">
          <div class="d-flex justify-content-end bg-dark text-light align-items-center px-3 py-2">
            <b-button size="sm" @click="hide" class="mr-3" variant="outline-warning">Cerrar</b-button>
            <b-button size="sm" @click="toggleSidebarSize" >
              <md-icon icon="keyboard_double_arrow_right" v-if="!isSidebarLarge"/> 
              <md-icon icon="keyboard_double_arrow_left" v-else/>
            </b-button>
          </div>
        </template>
      </b-sidebar>
    </div>
  </template>
  
  <script>
  import { mapState, mapActions } from 'vuex';
  import SupplierAnalisis from  "./modules/SupplierAnalisis.vue";
  import FlightsStatus from  "./modules/FlightsVerification.vue";
  export default {
    data() {
      return {
        isSidebarLarge: false, // New state to manage sidebar size
        modules: ['Module 1', 'Module 2', 'Module 3'],
      };
    },
    components:{SupplierAnalisis,FlightsStatus},
    computed: {
      ...mapState("highlights", ["isSidebarOpen","selectedModule"]),
      showFlightsStatusModule(){
          // Check if the current route matches "operation/live"
          //return window.location.pathname === "/operation/live";
          return true;
      }
    },
    methods: {
      ...mapActions('highlights', ["toggleSidebar","selectModule"]),
      // Method to toggle the sidebar size
      toggleSidebarSize() {
        this.isSidebarLarge = !this.isSidebarLarge;
      },
    },
  };
  </script>
<style>
@media (min-width: 1200px){
	.sidebar-highlight{
		width: 35vw !important;
	}
  .sidebar-large{
    width: 50vw !important;
  }
}
.sidebar-content {
    flex: 1; /* Allow content to grow and fill available space */
}


.folder-tab {
  background-color: #f8f9fa; /* Light background color */
  padding: 10px; /* Spacing around the tab */
  border-bottom: 1px solid #ced4da; /* Add a border for separation */
}

.folder-button {
  background-color: #007bff; /* Button color */
  color: white; /* Text color */
  border-radius: 4px 4px 0 0; /* Rounded corners */
  padding: 10px 20px; /* Padding around the button */
  transition: background-color 0.3s; /* Smooth transition */
}

.folder-button:hover {
  background-color: #0056b3; /* Darker shade on hover */
}

.content {
  padding: 20px; /* Content area padding */
}
.dropdown-menu {
  z-index: 1050 !important; /* Make sure it appears above the sidebar */
}
</style>
  